<template>
  <ContentCenter class="bg-color-load-blue radial-gradient-loading">
    <template #top>
      <div class="absolute bg-color-load-header-blue w-full md:h-32 h-1/6 top-0 down-stroke-white-2" />
    </template>

    <template #center>
      <!-- Desktop layout: side-by-side logo + login pill -->
      <div class="md:flex hidden w-full">
        <div class="flex justify-end items-center w-1/2">
          <div>
            <div class="flex justify-end w-full">
              <div class="w-2/3">
                <img src="/img/logo-masalafries-white.webp" :alt="$t('alt.logoLogin')" class="mb-3" />
              </div>
            </div>
            <div class="w-full flex justify-end">
              <div class="w-10/12 mr-12">
                <h2 class="text-white text-lg text-right">
                  {{ $t('message.toBegin') }}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="w-px h-96 line-loading-gradient mx-3"></div>
        <LoginForm />
      </div>

      <!-- Mobile layout: stacked vertical, portfolio logo on top, square login below -->
      <div class="md:hidden flex flex-col items-center justify-center w-full gap-6 px-6">
        <div class="w-3/5 max-w-[260px]">
          <img src="/img/logo-masalafries-white.webp" :alt="$t('alt.logoLogin')" />
        </div>
        <h2 class="text-white text-sm text-center opacity-80 px-4">
          {{ $t('message.toBegin') }}
        </h2>
        <LoginFormMobile />
      </div>
    </template>

    <template #bottom>
      <div class="absolute bg-color-load-header-blue w-full md:h-48 h-1/5 bottom-0 up-stroke-green-2">
        <div class="flex flex-col justify-center items-center h-full gap-3">
          <div class="flex text-white md:text-sm text-xs font-bold text-center px-4">
            <h4>{{ $t('message.explainer') }}</h4>
          </div>
          <p class="text-white text-s opacity-60 font-franklin">
            Best experienced on desktop
          </p>
        </div>
      </div>
    </template>
  </ContentCenter>
</template>

<script setup>
import LoginForm from '@/components/Loading/LoginForm.vue'
import LoginFormMobile from '@/components/Loading/LoginFormMobile.vue'
import ContentCenter from '@/layouts/ContentCenter.vue'
</script>
